module.exports = __webpack_public_path__ + "img/austria-genitourinary-diseases-female.72bcf966.png";